var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileSearchActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.559,
    height: 25.79,
    viewBox: "0 0 19.559 25.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-17.999 -365.378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3841",
    "data-name": "Group 3841",
    transform: "translate(0 70)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3699",
    "data-name": "Group 3699",
    transform: "translate(0.289 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3698",
    "data-name": "Group 3698",
    transform: "translate(17.576 293.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M26.217,6.309H25.168v.677a2.032,2.032,0,0,1-2.027,2.031H16.112a2.033,2.033,0,0,1-2.031-2.031V6.309H13.036A3.188,3.188,0,0,0,9.847,9.5V27.285a3.192,3.192,0,0,0,3.189,3.193H26.217a3.192,3.192,0,0,0,3.189-3.193V9.5A3.188,3.188,0,0,0,26.217,6.309ZM14.11,11.04a.8.8,0,0,1,.8-.8h9.432a.8.8,0,0,1,.8.8v1.271a.8.8,0,0,1-.8.8H14.908a.8.8,0,0,1-.8-.8Zm3.034,15.488a1.2,1.2,0,0,1-1.2,1.2H13.684a1.2,1.2,0,0,1-1.2-1.2V24.175a1.2,1.2,0,0,1,1.2-1.2H15.94a1.2,1.2,0,0,1,1.2,1.2Zm.109-6.933a1.229,1.229,0,0,1-1.233,1.229H13.709a1.228,1.228,0,0,1-1.229-1.229V17.188a1.228,1.228,0,0,1,1.229-1.229H16.02a1.229,1.229,0,0,1,1.233,1.229Zm9.518,7.355H19.625a.418.418,0,1,1,0-.836h7.145a.418.418,0,1,1,0,.836Zm0-2.248H19.625a.418.418,0,1,1,0-.836h7.145a.418.418,0,1,1,0,.836Zm0-4.769H19.625a.418.418,0,1,1,0-.836h7.145a.418.418,0,1,1,0,.836Zm0-2.248H19.625a.418.418,0,1,1,0-.836h7.145a.418.418,0,1,1,0,.836Z",
    transform: "translate(-9.712 -4.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M21.736,5.617h7.028a1.193,1.193,0,0,0,1.193-1.193V3.193A1.193,1.193,0,0,0,28.764,2H21.736a1.193,1.193,0,0,0-1.193,1.193v1.23A1.193,1.193,0,0,0,21.736,5.617Zm-.7,9.58-.826.562-.137-.233a.418.418,0,0,0-.721.424l.363.617a.418.418,0,0,0,.6.134l1.195-.812a.418.418,0,0,0-.47-.691Zm0,6.991-.826.562-.137-.233a.418.418,0,0,0-.721.424l.363.617a.418.418,0,0,0,.6.134l1.195-.812a.418.418,0,0,0-.47-.691Z",
    transform: "translate(-15.472 -2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_460",
    "data-name": "Rectangle 460",
    width: 17,
    height: 19,
    transform: "translate(18.71 298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_461",
    "data-name": "Rectangle 461",
    width: 5,
    height: 5,
    rx: 2.5,
    transform: "translate(24.41 303.35)",
    fill: "#487eda"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3840",
    "data-name": "Group 3840",
    transform: "translate(15494.341 22108.801)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass_1_",
    "data-name": "magnifying-glass (1)",
    transform: "translate(-15471.841 -21734.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14616",
    "data-name": "Path 14616",
    d: "M7.944,1.316A4.695,4.695,0,1,0,7.3,8.487a.988.988,0,0,0,.268.5l2.666,2.665a.992.992,0,1,0,1.4-1.4L8.973,7.582a.992.992,0,0,0-.5-.267A4.7,4.7,0,0,0,7.944,1.316ZM7.1,7.114a3.5,3.5,0,1,1,0-4.956,3.5,3.5,0,0,1,0,4.956Z",
    transform: "translate(0.071 -0.941)",
    fill: "#487eda"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSearchActive);
export default __webpack_public_path__ + "static/media/ProfileSearchActive.bb408a9dd2159985f78748e52e21b8d0.svg";
export { ForwardRef as ReactComponent };